/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

export { CancellationError } from '../../errors.js';
export { CancellationToken, CancellationTokenSource } from '../../cancellation.js';
